import React, { PropsWithChildren, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingSpinner } from 'edenred-ui';

import { useOnboardingWizard } from '@epi-shared/hooks';
import { goToPage } from '@epi-actions/navigation';

interface OnboardingRouteProps {
  path: string;
}

export const OnboardingRoute = ({
  path,
  children
}: PropsWithChildren<OnboardingRouteProps>) => {
  const dispatch = useDispatch();
  const {
    isOnBoardingActive,
    isLoading,
    checkIfPathIsAllowed,
    lastAllowedStep
  } = useOnboardingWizard();

  useEffect(() => {
    if (isOnBoardingActive && !checkIfPathIsAllowed(path)) {
      dispatch(goToPage(lastAllowedStep.path));
    }
  }, [isOnBoardingActive, lastAllowedStep, path]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isOnBoardingActive || checkIfPathIsAllowed(path)) {
    return children;
  }

  return null;
};
